import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { McpToolName } from '@systemeio/ai-chat-types';
import { AiChatButton, AiChatWidgetProps, useWidgetControls } from '@systemeio/ai-chat-widget';
import { useRevalidateModules } from '@systemeio/util';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { Suspense, lazy } from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
const Widget = lazy(() => import('@systemeio/ai-chat-widget').then(m => ({
  default: m.AiChatWidget
})));
export const AiChatTriggerButton = () => {
  const $ = _c(7);
  const aiChatFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.AiChat);
  const {
    open,
    setOpen
  } = useWidgetControls();
  if (!aiChatFeatureIsOn) {
    return null;
  }
  let t0;
  if ($[0] !== setOpen) {
    t0 = <AiChatButton onClick={() => {
      setOpen(_temp);
    }} />;
    $[0] = setOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== open) {
    t1 = open && <AiChatModal />;
    $[2] = open;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="ai-chat-widget">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const AiChatModal = () => {
  const $ = _c(7);
  const {
    setOpen
  } = useWidgetControls();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] !== revalidateModules) {
    t0 = toolCall => {
      bb2: switch (toolCall.toolName) {
        case McpToolName.AssignContactTag:
        case McpToolName.RemoveContactTag:
        case McpToolName.CreateContact:
        case McpToolName.RemoveContact:
        case McpToolName.UpdateContact:
          {
            revalidateModules([RequestModuleEnum.Contacts], true);
            break bb2;
          }
        case McpToolName.CreateTag:
        case McpToolName.RemoveTag:
        case McpToolName.UpdateTag:
          {
            revalidateModules([RequestModuleEnum.Tags], true);
            break bb2;
          }
        default:
      }
    };
    $[0] = revalidateModules;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleToolCallOutput = t0;
  let t1;
  if ($[2] !== setOpen) {
    t1 = () => setOpen(false);
    $[2] = setOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== handleToolCallOutput || $[5] !== t1) {
    t2 = <Suspense fallback={null}><Widget onToolCallOutput={handleToolCallOutput} onClose={t1} /></Suspense>;
    $[4] = handleToolCallOutput;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(prev) {
  return !prev;
}